import React, { useState } from "react";
import classNames from "classnames";
import * as c from "./singleProviderWarning.module.scss";
import FlowStepContainer from "@components/flows/shared/flowStepContainer";
import ToggleButton from "@components/ui/toggleButton";
import { Button } from "@components/shared";
import PricingPlan from "@components/pages/pricing/pricingPlan";

export default function SingleProviderWarning({ toggleLabel, buttonLabel, onContinue }) {
  const [checked, setChecked] = useState(false);

  return (
    <FlowStepContainer
      overrideStepLabel="A note to solo providers:"
      title="We think you're awesome but..."
      innerCtnClass={c.innerCtn}
    >
      <div className={c.container}>
        <p className={classNames(c.desc, "p3")}>
          Mangomint is designed for larger businesses with more staff members. You may find that another platform is a
          better fit.
        </p>
        <Button linkTo="/pricing/" className={classNames(c.btn, c.visible, c.pricingBtn)}>
          See our plans & pricing
        </Button>
        <div className={c.plansInner}>
          <PricingPlan name="Essentials" price="165" mainLimit="For small teams" aspects={[""]} />
          <PricingPlan name="Standard" price="245" mainLimit="For busy salons & spas" aspects={[""]} />
          <PricingPlan name="Unlimited" price="375" mainLimit="For large businesses" aspects={[""]} />
        </div>
        <div className={c.toggleContainer}>
          <ToggleButton label={toggleLabel} checked={checked} onChange={(checked) => setChecked(checked)} />
        </div>
        <Button asHtmlButton onClick={onContinue} className={classNames(c.btn, { [c.visible]: checked })}>
          {buttonLabel}
        </Button>
      </div>
    </FlowStepContainer>
  );
}
